<template>
  <div class="scroll-box enable-scroll">
    <div class="box">
      <MainHalfTitle text="測試者資料"></MainHalfTitle>
      <div class="row">
        <div class="item">測試者全名：</div>
        <div class="value">{{ data.name }}</div>
      </div>
      <div class="row">
        <div class="item">性別：</div>
        <div class="value">{{ data.sex }}</div>
      </div>
      <div class="row">
        <div class="item">出生年份：</div>
        <div class="value">{{ data.birth_year }}</div>
      </div>
      <div class="row">
        <div class="item">手提電話號碼：</div>
        <div class="value">{{ data.show_mobile }}</div>
      </div>
      <div class="row">
        <div class="item">教育程度：</div>
        <div class="value">{{ data.education_level }}</div>
      </div>
      <div class="row">
        <div class="item">居住地區：</div>
        <div class="value" v-if="show_district">{{ data.district }}</div>
        <select class="select" v-if="show_district_select" v-model="district_level1" @change="getDistrictLevel1Value">
          <option v-for="item in district_level1_option" v-bind:key="item.id" :value="item.id">{{ item.name }}</option>
        </select>
        &nbsp;
        <select class="select" v-if="show_district_select" v-model="district_level2" @change="getDistrictLevel2Value">
          <option v-for="item in district_level2_option" v-bind:key="item.id" :value="item.id">{{ item.name + (item.remark
            ?
            `(${item.remark})` : '') }}
          </option>
        </select>
        &nbsp;
        <select class="select" v-if="show_district_level3" v-model="district_level3">
          <option v-for="item in district_level3_option" v-bind:key="item.id" :value="item.id">{{ item.name }}
          </option>
        </select>
      </div>
      <div class="row">
        <div class="item">參考編號：</div>
        <div class="value">{{ data.number }}</div>
      </div>

      <div class="button-box">
        <ion-button class="button" @click="goTest">開始測試</ion-button>
        <ion-button class="button white-button" @click="showTestResult">最新測試結果</ion-button>
        <ion-button class="button white-button" @click="showHealthTips">健康小貼士</ion-button>
      </div>

    </div>

    <AlertModal :element="this" css_class="alert-modal-short home-start-test-modal" show_confirm="true" confirm_text="開始測試"
      :confirm_fun="confirmFun" text_align="text-center"></AlertModal>
  </div>
</template>

<script>

import MainHalfTitle from "@/components/common/MainHalfTitle";
import { IonButton } from "@ionic/vue";
import router from "@/router";
import common from "@/common";
import AlertModal from "@/components/common/AlertModal";
import forceUpdateAlert from '@/utils/forceUpdateAlert';
import { requestMicrophonePermission } from '@/utils/microphonePermission';

export default {
  name: "HomeUserInfo",
  components: {
    AlertModal,
    MainHalfTitle,
    IonButton
  },
  props: {
    data: { type: Object },
    districtList: { type: Array }
  },
  emits: ['updateUser', 'showTestResult', 'showHealthTips'],
  data() {
    return {
      common: common,
      show_district: false,
      show_district_select: false,
      show_district_level3: false,
      districts: [],
      district_level1: 0,
      district_level2: 0,
      district_level3: 0,
      district_level1_option: [{ id: 0, name: '請選擇' }],
      district_level2_option: [{ id: 0, name: '請選擇' }],
      district_level3_option: [{ id: 0, name: '請選擇' }],
    }
  },
  created() {
    this.common.config.alertModal.isOpen = false;
    this.getShowDistrict(this.data.district);
  },
  watch: {
    // 每当 data 改变时，这个函数就会执行
    data: {
      handler(newValue) {
        this.getShowDistrict(newValue.district);
      },
      deep: true
    },
    // 每当 districtList 改变时，这个函数就会执行
    districtList: {
      handler(newValue) {
        this.districts = newValue;
        this.getDistrictLevel1List();
      },
      deep: true
    }
  },
  methods: {
    getShowDistrict(value) {
      if (value !== '') {
        this.show_district = true;
        this.show_district_select = false;
      }
      else {
        this.show_district_select = true;
        this.show_district = false;
        if (this.districtList.length !== 0) {
          this.districts = this.districtList;
          this.getDistrictLevel1List();
        }
      }
    },
    getDistrictLevel1List: function () {
      this.district_level1_option = [{ id: 0, name: '請選擇' }];
      const districts = this.districts.filter(p => p.level === 1);
      districts.forEach(element => {
        this.district_level1_option.push(element);
      });
    },
    getDistrictLevel2List: function (value) {
      this.district_level2_option = [{ id: 0, name: '請選擇' }];
      const districts = this.districts.filter(p => p.level === 2 && p.parent_id === value);
      districts.forEach(element => {
        this.district_level2_option.push(element);
      });
      this.district_level2 = 0;
    },
    getDistrictLevel3List: function (value) {
      this.district_level3_option = [{ id: 0, name: '請選擇' }];
      const districts = this.districts.filter(p => p.level === 3 && p.parent_id === value);
      districts.forEach(element => {
        this.district_level3_option.push(element);
      });
      this.district_level3 = 0;
    },
    getDistrictLevel1Value: function () {
      this.getDistrictLevel2List(this.district_level1);
      this.show_district_level3 = false;
      this.district_level3 = 0;
    },
    getDistrictLevel2Value: function () {
      if (this.district_level2 === 31) {
        this.show_district_level3 = true;
        this.getDistrictLevel3List(this.district_level2);
      }
      else {
        this.show_district_level3 = false;
        this.district_level3 = 0;
      }
    },
    getAreaDistrictlText: function (level1Value, level2Value, level3Value) {
      const level1 = this.district_level1_option.find(function (item) {
        return item.id == level1Value
      })
      const level2 = this.district_level2_option.find(function (item) {
        return item.id == level2Value
      })
      if (level3Value !== 0) {
        const level3 = this.district_level3_option.find(function (item) {
          return item.id == level3Value
        })
        return level1.name + '-' + level2.name + (level2.remark ? `(${level2.remark})` : '') + '-' + level3.name;
      }
      else {
        return level1.name + '-' + level2.name + (level2.remark ? `(${level2.remark})` : '');
      }
    },
    goTest: function () {
      if (this.show_district_select === true) {
        if (this.district_level1 === 0 || this.district_level2 === 0 || this.show_district_level3 === true && this.district_level3 === 0) {
          common.showAlert('請選擇居住地區。');
          return;
        }
      }
      this.common.config.alertModal.isOpen = true;
      this.common.config.alertModal.title = '請確認測試者資料';
      this.common.config.alertModal.content = [
        '測試者全名：' + this.data.name,
        '性別：' + this.data.sex,
        '出生年份：' + this.data.birth_year,
        '教育程度：' + this.data.education_level,
        this.show_district_select === true ? '居住地區：' + this.getAreaDistrictlText(this.district_level1, this.district_level2, this.district_level3) : '居住地區：' + this.data.district
      ]

      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const that = this;
      this.common.config.alertModal.didDismissFun = function () {
        that.common.config.alertModal.isOpen = false;
      }
    },
    confirmFun: async function () {
      await requestMicrophonePermission();

      await forceUpdateAlert(() => {
        if (this.show_district_select === true) {
          if (this.show_district_level3 !== true) {
            this.$emit('updateUser', this.data.id, this.district_level2);
          }
          else {
            this.$emit('updateUser', this.data.id, this.district_level3);
          }
        }
        else {
          common.setStorage('user_info',
            {
              id: this.data.id,
              number: this.data.number,
              mobile: this.data.mobile,
              show_mobile: common.splitMobile(this.data.mobile),
              name: this.data.name,
              district: this.data.district,
              ngo_id: this.data.organization.id,
              ngo_name: this.data.organization.name,
              ngo_address: this.data.organization.address,
              ngo_phone: this.data.organization.phone
            }
          );
          router.replace('/testPrepare')
        }
      });
    },
    showTestResult: function () {
      this.$emit('showTestResult')
    },
    showHealthTips: function () {
      this.$emit('showHealthTips')
    },
  }
}
</script>

<style scoped>
.select {
  width: var(--ecs-control-width-sm);
  max-width: 90vw;
  box-sizing: border-box;
  min-height: var(--ecs-form-control-min-height);
  padding: var(--ecs-form-control-padding-y) var(--ecs-form-control-padding-x);
}

.box {
  text-align: center;
}

.box > :deep(.box:first-child) {
  margin-top: clamp(0.75rem, 2vw, 1.5rem);
}

@media (orientation: landscape) and (max-height: 480px) {
  .box > :deep(.box:first-child) {
    margin-top: clamp(0.1875rem, 0.5vw, 0.375rem);
  }
}

.row {
  display: flex;
  align-items: start;
  text-align: left;
  font-size: var(--ecs-font-md);
  /* margin-left: 10%; */
  padding: clamp(0.5rem, 1vw, 0.75rem);
  line-height: 1.3;
}

.item {
  display: inline-block;
  width: var(--ecs-label-width);
  text-align: right;
  margin-right: clamp(0.75rem, 2vw, 1.5rem);
}

.value {
  display: inline-block;
  width: var(--ecs-control-width-sm);
  max-width: 90vw;
}

.button-box {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  gap: clamp(.5rem, 2vw, 1rem);
  padding: 0 clamp(0.5rem, 1.5vw, 1rem);;
  margin-top: clamp(1rem, 3vw, 2rem);
  padding-bottom: clamp(1rem, 3vw, 2rem);
}

.button {
  --background: #94c43b;
  width: clamp(8rem, 31%, 13rem);
  min-height: var(--ecs-button-min-height);
  height: auto;
  margin: 0;
  white-space: normal;
  font-size: var(--ecs-font-md);
  line-height: 1.3;
}

.white-button {
  --background: white;
  color: #94c43b;
  border: 2px #94c43b solid;
  border-radius: 6px;
}

@media (orientation: landscape) and (max-height: 480px) {
  .row {
    padding: clamp(0.25rem, 0.5vw, 0.375rem);
  }

  .item {
    margin-right: clamp(0.375rem, 1vw, 0.75rem);
  }

  .button-box {
    margin-top: clamp(0.5rem, 1.5vw, 1rem);
    padding-bottom: clamp(0.5rem, 1.5vw, 1rem);
  }

  .button {
    min-height: clamp(2.5rem, 5vw, 3rem);
  }

  .select {
    min-height: var(--ecs-form-control-min-height);
  }
}
</style>
